<template>
  <tw-list-group-item :class="[supportRequest.status === 'closed'?'bg-green-50': 'bg-gray-100', 'p-6 hover:bg-white']">
    <div class="float-right flex gap-2">
      <tw-badge :variant="variantStatuses[supportRequest.status]" class="mr-1">
        <icon icon="signal" class="mr-1" /> {{ $filters.formatString(supportRequest.status) }}
      </tw-badge>
      <tw-badge v-if="supportRequest.user" variant="amber">
        <icon icon="user" class="mr-1" /> {{ supportRequest.user.name }}
      </tw-badge>
      <tw-badge v-if="loggedInUser.admin && supportRequest.organization">
        <icon icon="info-circle" /> {{ supportRequest.organization.name }}
      </tw-badge>
      <tw-badge variant="green">
        {{ $filters.formatDate(supportRequest.created_at) }}
      </tw-badge>
      <tw-badge v-if="supportRequest.closed_at" variant="success" class="float-right mr-1">
        Closed at: {{ $filters.formatDate(supportRequest.closed_at) }}
      </tw-badge>
    </div>
    <h4>
      <router-link :to="{name: 'support-request-page', params: {supportRequestId: supportRequest.id} }">
        Support Request #{{ supportRequest.id }}
      </router-link>
    </h4>

    <div class="grid grid-cols-12">
      <div class="col-span-11">
        <router-link :to="{name: 'support-request-page', params: {supportRequestId: supportRequest.id} }">
          {{ supportRequest.message }}
        </router-link>
        <tw-badge v-if="supportRequest.support_request_messages_count" variant="primary">
          {{ supportRequest.support_request_messages_count }} replies
        </tw-badge>
      </div>
      <div v-if="supportRequest.screenshot_upload" class="col-span-1" md="1">
        <a target="_blank" :href="supportRequest.screenshot_upload.url">
          <tw-img style="max-height: 120px; overflow: auto" :src="supportRequest.screenshot_upload.url" thumbnail /></a>
      </div>
    </div>
  </tw-list-group-item>
</template>

<script>

import TwListGroupItem from '@/components/generic/list-group/tw-list-group-item.vue'
import TwBadge from '@/components/generic/tw-badge.vue'
import TwImg from '@/components/images/tw-img.vue'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'

export default {
  name: 'SupportRequestListGroupItem',
  components: { TwImg, TwBadge, TwListGroupItem },
  mixins: [loggedInUserMixin],
  props: {
    supportRequest: {
      type: Object,
      required: true
    }
  },
  computed: {
    variantStatuses () {
      return {
        pending: 'amber',
        in_progress: 'blue',
        closed: 'green'
      }
    }
  }
}
</script>

<style scoped>

</style>
